// ABOUTME: Names shared across the job listings module: the pro-core path, the React Query keys, the error codes the
// ABOUTME: screens branch on, the page size and the number of saved points a talent may keep.
/**
 * The listing resource on pro-core. `/talent/listings` is its name going forward (zenjob/pro-core-service#2092); the old
 * `/talent/jobListings` answers the same handlers until PJL-070 removes it, so builds still on it keep working.
 */
export const JOB_LISTINGS_API_URL = 'talent/listings';

export const USE_JOB_LISTINGS_QUERY_KEY = 'jobListings';
export const USE_JOB_LISTING_QUERY_KEY = 'jobListing';
export const USE_SEARCH_PREFERENCES_QUERY_KEY = 'jobListingSearchPreferences';
export const USE_FILTER_OPTIONS_QUERY_KEY = 'jobListingFilterOptions';
export const SAVE_SEARCH_PREFERENCES_MUTATION_KEY =
  'saveJobListingSearchPreferences';

/** The code a 404 from pro-core is mapped to: PRO_JOB_LISTING is off for this talent, or the route is not deployed. */
export const JOB_LISTINGS_UNAVAILABLE_ERROR_CODE =
  'error.job-listings.unavailable';

/** No such listing, or not one I may see: the same answer either way, so the route confirms nothing. */
export const JOB_LISTING_NOT_FOUND_ERROR_CODE = 'error.job-listing.not-found';

/** A radius without a point or a point without a radius; the app never sends half a point, this is the belt to those braces. */
export const JOB_LISTING_SEARCH_POINT_REQUIRED_ERROR_CODE =
  'error.job-listing.search.point-required';

/** The only place the number three appears: pro-core refuses a fourth point, and the app refuses it before asking. */
export const MAX_SAVED_POINTS = 3;

/** pro-core's limit on a saved search's or point's label; the field stops there rather than letting the save fail. */
export const MAX_LABEL_LENGTH = 60;

export const PAGE_SIZE = 20;

/** Session storage: the criteria the feed was last read with, so a visit to a job does not reset the search. */
export const JOB_FEED_CRITERIA_KEY = 'jobs.feed.criteria';

/** POST here with { jobListingRefId }: 201 with the new application's refId, 200 with the one I already had. */
export const APPLY_API_URL = 'talent/applications';
/** PJL: the talent's assignments, whose `/{assignmentRefId}/job` is the job page of my job. */
export const ASSIGNMENT_JOB_API_URL = 'talent/assignments';
/** PJL: the job of an application and the job of my job, read for their job pages. */
export const USE_APPLICATION_JOB_QUERY_KEY = 'applicationJob';
export const USE_ASSIGNMENT_JOB_QUERY_KEY = 'assignmentJob';
export const APPLY_MUTATION_KEY = 'applyToJobListing';
/** 409: the opening is no longer taking applications, because its process is closed or has no entry step. */
export const APPLY_NOT_POSSIBLE_ERROR_CODE =
  'error.job-listing.apply-not-possible';
/** The React Query key of "does this talent have a PRO CV", read once for the apply footer's line. */
export const USE_PRO_CV_QUERY_KEY = 'proCvExists';

/** PJL: the commute to a listing's places, asked per travel mode on a tap. */
export const USE_COMMUTE_QUERY_KEY = 'jobListingCommute';
/** PJL: the apply flow's week check of one listing against a week. */
export const USE_WEEK_FIT_QUERY_KEY = 'jobListingWeekFit';
